import React from 'react';

class PrimaryButton extends React.Component {

    render() {
        return (
            <button onClick={this.props.onClick} className='btn btn-primary'>
                {this.props.children}
            </button>
        )
    }
}

export default PrimaryButton



// WEBPACK FOOTER //
// ./src/components/PrimaryButton/index.js